module.exports = __webpack_public_path__ + "static/media/timelapse_5.973b4624.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_5.jpg
// module id = 965
// module chunks = 0